import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
import { Observable } from 'rxjs';
import { Datossopa } from 'src/app/modelos/datos/datossopa.model';
///variable de jquey para modal//
declare var $: any;
@Component({
  selector: 'app-realizadorsopa',
  templateUrl: './realizadorsopa.component.html',
  styleUrls: ['./realizadorsopa.component.css']
})
export class RealizadorsopaComponent implements OnInit {

  public nombrerealizador: string = "";
  public accederActividad: boolean;
  public minutos: number = 0;
  public signo: string = "";
  public uid:string="";
  segundos: number = 0;
  interval;
  public claveActividad: string;
  public datosActividad: Observable<Datossopa>;
  public celdas: Array<number>;
  public descripcion: string;
  public dificultad: string;
  public operacion: string;
  public resultados: Array<number>;
  public titulo: string;
  public numero1: number = null;
  public numero2: number = null;
  public resultado: number;
  public aciertos: number = 0;
  public errores: number = 0;
  public restantes: number = 0;
  public indexresultado: number = 0;
  public calificacion: number

  public constructor(public route: ActivatedRoute, public router: Router, private serivicio: ServicioFirebaseService) {
  }

  ngOnInit() {
    this.route.params.forEach(params => {
      let clave = params["clave"];
      this.claveActividad = this.claveActividad;
      this.datosActividad = this.serivicio.tomarInformacionActividad(clave);
      this.datosActividad.subscribe(res => {
        this.uid=res.uid;
        this.celdas = res.celdas;
        this.descripcion = res.descripcion;
        this.dificultad = res.dificultad;
        this.operacion = res.operacion;
        this.resultados = res.resultados;
        this.titulo = res.titulo;
        this.resultado = this.resultados[this.indexresultado];
        this.restantes = this.resultados.length;
        switch (res.operacion) {
          case "suma":
            this.signo = "+";
            break;
          case "resta":
            this.signo = "-";
            break;
          case "multiplicacion":
            this.signo = "x";
            break;
        }
      });

    })
    this.mostarModal("#myModal");
    //this.startTimer();
  }
  iniciarTimer() {
    this.interval = setInterval(() => {
      if (this.segundos == 59) {
        this.segundos = 0;
        this.minutos++;
      } else {
        this.segundos++;
      }
    }, 1000)
  }
  pausarTimer() {
    clearInterval(this.interval);
  }
  empezarActividad() {
    if (this.nombrerealizador != "") {
      this.esconderModal("#myModal");
      this.iniciarTimer();
      this.accederActividad = true;
    } else {
      this.accederActividad = false;

    }
  }
  realizarOperacion(numero) {
    if (this.numero1 == null) {
      this.numero1 = parseInt(numero);
    } else {
      this.numero2 = parseInt(numero);
      switch (this.operacion) {
        case "suma":
          setTimeout(() => {
            this.operacionSuma();
            this.continuar();
          }, 500);
          break;
        case "resta":
          setTimeout(() => {
            this.operacionResta();
            this.continuar();
          }, 500);
          break;
        case "multiplicacion":
          setTimeout(() => {
            this.operacionMulti();
          }, 500);
        break;

      }
    }
  }
  operacionSuma() {
    if ((this.numero1 + this.numero2) == this.resultado) {
      this.aciertos++;
    }
    else {
      this.errores++;
    }
  }
  operacionMulti() {
    if ((this.numero1 + this.numero2) == this.resultado) {
      this.aciertos++;
    }
    else {
      this.errores++;
    }
  }
  operacionResta() {
    if ((this.numero1 - this.numero2) == this.resultado) {
      this.aciertos++;
    }
    else {
      this.errores++;
    }
  }
  private continuar() {
    this.restantes--;
    if (this.restantes != 0) {
      this.indexresultado = this.indexresultado + 1;
      this.resultado = this.resultados[this.indexresultado];
      this.numero1 = null;
      this.numero2 = null;
    }
    else {
      this.terminarActividad();
    }
  }
  terminarActividad() {
    this.calificacion = Math.floor((this.aciertos / this.resultados.length) * 100);
    this.mostarModal("#myModal-calificacion");
    this.pausarTimer();
    var tiempo=this.minutos.toString()+":"+this.segundos.toString();
    this.serivicio.registrarActividadHecha(this.calificacion.toString(),this.nombrerealizador,tiempo,"sopa",this.titulo,this.uid);
  }
  mostarModal(id: string): void {
    $(id).modal('show');
  }
  esconderModal(id: string) {
    $(id).modal('hide');
  }


}
